import { all, takeLatest, put, race, take } from 'redux-saga/effects'
import { SUCCESS, FAILED } from 'crom-api-constants'
import _ from 'lodash'

import { LOAD_HISTORY, LOAD_HISTORY_REQUEST, LOCALE_PREFIX } from './constants'

import { error } from '../../../../../../../../services/toastr'

import { loadHistoryRequest, historyLoaded } from './actions'

const LOAD_HISTORY_REQUEST_SUCCESS = `${LOAD_HISTORY_REQUEST}_${SUCCESS}`
const LOAD_HISTORY_REQUEST_FAILED = `${LOAD_HISTORY_REQUEST}_${FAILED}`

function* loadHistoryCallSaga() {
    yield put(loadHistoryRequest())

    const result = yield race({
        success: take(LOAD_HISTORY_REQUEST_SUCCESS),
        failed: take(LOAD_HISTORY_REQUEST_FAILED),
    })

    if (!result.failed) {
        const data = _.get(result, 'success.payload.response.body.data.history', [])

        yield put(historyLoaded(data))
    } else {
        error({
            id: `${LOCALE_PREFIX}.getError`,
        })
    }

    return null
}

export default function* historySaga() {
    yield all([takeLatest(LOAD_HISTORY, loadHistoryCallSaga)])
}
